import getData from "../Data/data.js";
import Async from "react-async";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


function SkillRow(data) {
  let skills = '';
  data.skills[data.skillCat].forEach(skill=> {
    skills = skills + skill + ', '
  });
  skills = skills.slice(0, -2);
  return <td>{skills}</td>
}

function SkillsCategories(data){
  let skillsbyCat = [];
  Object.keys(data.data).forEach(skillCat => {
    skillsbyCat.push(<tr>
                         <td><ul><li>{skillCat}</li></ul></td>
                         <td><SkillRow skillCat={skillCat} skills={data.data}/></td>
                     </tr>)
  });
  return <table>{skillsbyCat}</table>;
}

function SkillsByCategories() {
  return (
    <Async promiseFn={getData} endpoint={'skills'}> 
    {({ data, error, isPending }) => {
      if (isPending) return (<><h1><Skeleton /></h1><Skeleton count={10}/></>);
      if (error) return `Something went wrong: ${error.message}`
      if (data)  return <SkillsCategories data={data}/>
      return null
    }}
  </Async> );
}

function Skills(){
    return (
      <section>
        <h1>Skills</h1>
        <hr></hr>
        <SkillsByCategories />
        {/* <table>
          <tr>
            <td><ul><li>Languages</li></ul></td>
            <td>Java, Javascript</td>
          </tr>
          <tr>
            <td><ul><li>Frameworks/libraries</li></ul></td>
            <td>Java, Javascript</td>
          </tr>
          <tr>
            <td><ul><li>Tools</li></ul></td>
            <td>Java, Javascript</td>
          </tr>
          <tr>
            <td><ul><li>Architecture</li></ul></td>
            <td>Java, Javascript</td>
          </tr>
          <tr>
            <td><ul><li>Methodologies</li></ul></td>
            <td>Java, Javascript</td>
          </tr>                                        
        </table> */}
      </section>
    );
}

export default Skills;